import http from "@/apps/shared/baseService/config";

const base = {
  rota: "external_movimentations",
  nome: "Entregas"
};

export const service = {
  listar_minhas: data => http.post(`/admin/${base.rota}/list-my-deliveries`, data),
  atualizar_status: data => http.post(`/admin/${base.rota}/update-status`, data),
  comentar: data => http.post(`/admin/${base.rota}/add-comment`, data)
};

const module = {
  actions: {
    listar_entregas: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .listar_minhas(getters.get_entregas_filtros)
        .then(res => {
          dispatch("disableLoading");
          commit("set_entregas", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response && e.response.data ? e.response.data.message : e.message,
            timeout: 6000
          });
        });
    }
  },
  state: {
    entregas: {
      docs: [],
      summary: {}
    },
    entregas_filtros: {
      status: "",
      date: "",
      search: "",
      scope: "mine",
      unity: null
    }
  },
  mutations: {
    set_entregas: (state, payload) => (state.entregas = payload),
    set_entregas_filtros: (state, payload) => (state.entregas_filtros = payload)
  },
  getters: {
    get_entregas: state => state.entregas,
    get_entregas_filtros: state => state.entregas_filtros
  }
};

const routes = [
  {
    path: "/entregas",
    component: () => import("./views/Main.vue"),
    name: base.nome
  },
  {
    path: "/entregas/player/:id",
    component: () => import("./views/Player.vue"),
    name: "Player de Entregas"
  }
];

export default {
  service,
  module,
  routes
};
